import { StreamActions, StreamElement } from '@hotwired/turbo'
import { Turbo } from '@hotwired/turbo-rails'

StreamActions.redirect_to = function (this: StreamElement) {
  const target = this.getAttribute('location')
  const method = this.getAttribute('method') || 'replace'

  if (!target) {
    console.warn('No target to redirect for Turbo action redirect_to. Skipping.')
    return
  }

  Turbo.cache.clear()
  Turbo.visit(target, { action: method })
}
